import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFooterStore = defineStore('footerStore', () => {
  const openFooter = ref<boolean>(false)
  const openSummary = ref<boolean>(false)

  function setOpenFooter(value: boolean): void {
    openFooter.value = value
    if (value) {
      setOpenSummary(false) // Cierra el summary si se abre el footer
    }
  }

  function getOpenFooter(): boolean {
    return openFooter.value
  }

  function setOpenSummary(value: boolean): void {
    openSummary.value = value
    if (value) {
      setOpenFooter(false) // Cierra el footer si se abre el summary
    }
  }

  function getOpenSummary(): boolean {
    return openSummary.value
  }

  function toggleSummary(): void {
    openSummary.value = !openSummary.value
    if (openSummary.value) {
      setOpenFooter(false) // Cierra el footer si se abre el summary
    }
  }
  return {
    openFooter,
    openSummary,
    setOpenFooter,
    getOpenFooter,
    setOpenSummary,
    getOpenSummary,
    toggleSummary
  }
})
